export const CANNED_ACTION_TYPES = [
  {
    key: 'send_attachment',
    label: 'Send Attachment',
    inputType: 'attachment',
    attributeI18nKey: 'SEND_ATTACHMENT',
  },
];
